<template>
    <div class="container">
        <div class="columns is-vcentered mt-6 has-background-dvodark is-full">
            <div class="column">
                <div class="has-text-centered">
                    <p class="title is-4 has-text-white">Need To Register A Product? Please Enter Your Information Below</p>
                    <p class="subtitle is-6 has-text-white">This item will be registered to you</p>
                    <b-field horizontal label="Your Item's Serial #">
                        <input class="input" type="text" v-model="itemToRegister" @input="handleItemChange(itemToRegister)"/>
                    </b-field>
                    <b-field v-if="selectedItem" horizontal label="Is This Your Product?">
                        <span class="has-text-white">
                            {{ selectedItem.description }}
                        </span>
                    </b-field>
                    <b-field horizontal label="The Date of Purchase">
                        <b-datepicker v-model="dateOfPurchase" locale="en-US"  :min-date="computedMinDate"  :max-date="maxDate" placeholder="Click to select..."
                            icon="calendar-today" trap-focus>
                        </b-datepicker>
                    </b-field>
                    <!-- <b-field horizontal label="Proof of Purchase (Optional)" class="file is-primary"
                        :class="{'has-name': !!file}">
                        <b-upload v-model="file" class="file-label">
                            <span class="file-cta">
                                <b-icon class="file-icon" icon="upload"></b-icon>
                                <span class="file-label">Click to upload</span>
                            </span>
                            <span class="file-name" v-if="file">
                                {{ file.name }}
                            </span>
                        </b-upload>
                    </b-field> -->
                </div>
            </div>
        </div>
        <div class="columns has-background-dvodark mb-6">
            <div class="column">
                <div class="columns is-centered mb-2">
                    <div class="column has-text-centered">
                        <b-button @click="submitItemRegistration()" class="is-primary is-large" :loading="isLoading">Submit</b-button>
                        <p v-if="isSuccess" class="has-text-dvogreen">Request Successfully Made</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { mapState } from "vuex";
import { personHandler, itemHandler } from '../graphql/mutations'
import { getItemWithProduct } from '../graphql/queries'


export default {
    data() {
        return {
            itemToRegister: null,
            selectedItem: null,
            dateOfPurchase: new Date(),
            file: null,
            invalidItem: false,
            userId: null,
            isLoading: false,
            maxDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            isSuccess: false
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        }),
        computedPurchaseDate: function(){
            return this.dateOfPurchase.toISOString().slice(0, 10)
        },
        computedItemSerial: function(){
            if(this.selectedItem.serial){
                return true
            } else {
                return false
            }
        },
        computedMinDate(){
            if(this.selectedItem){
                return new Date(this.selectedItem.date_production)

            } else {
                return new Date()
            }
        }
    },
    methods: {
        async getUserInfo() {
            const dvoUser = await API.graphql({
                query: personHandler,
                variables: {
                    input: {
                        cognito_id: this.user.attributes.sub,
                        request_type: 'read_by_cognito_id'
                    }
                }
            });
            this.userId = dvoUser.data.personHandler.id
        },
        async handleItemChange(inputItem) {
            this.invalidItem = false;

            const item = await API.graphql({
                query: getItemWithProduct,
                variables: {
                    input: {
                        request_type: 'read_one_with_product',
                        serial: inputItem.trim()
                    }
                }
            });
            this.selectedItem = item.data.getItemWithProduct;
            console.log(this.selectedItem)
            if (this.selectedItem === null) {
                this.invalidItem = true;
                this.noItemNotification();
            }
        },
        noItemNotification() {
            const notif = this.$buefy.notification.open({
                duration: 2000,
                message: `<b>Item with this serial number does not exist. Please enter a valid serial number. If you believe this is in error, please contact support</b>`,
                position: 'is-bottom',
                type: 'is-danger',
                hasIcon: true
            })
            notif.$on('close', () => {
                // this.$buefy.notification.open('Custom notification closed!')
                console.log('closed')
            })
        },
        async submitItemRegistration(){
            if(this.computedItemSerial && !this.invalidItem){
            this.isLoading = true;
            this.isSuccess = false;
            await API.graphql({
                query: itemHandler,
                variables: {
                input: {
                    request_type: 'update_person',
                    person_id: this.userId,
                    serial: this.selectedItem.serial
                }}
            });
            await API.graphql({
                query: itemHandler,
                variables: {
                input: {
                    request_type: 'update_date_purchase',
                    date_purchase: this.computedPurchaseDate,
                    serial: this.selectedItem.serial
                }}
            });
            this.isLoading = false;
            this.isSuccess = true;
            } else {
                console.log("invalid attempt")
            }
        }
    },
    mounted() {
        this.getUserInfo()
    }
}
</script>

<style>
.is-full{
    min-height: 80vh;
}

.title{
  font-family:  'Anton', sans-serif;
}
</style>